/* Global imports. */
import React from "react";
import { Link } from "gatsby"

interface Props {
  url: string;
  contributorName: string;
  className?: string;
}

function ContributorLink({ url, contributorName, className }: Props) {
  return <Link className={className} to={`/${url}`}><span dangerouslySetInnerHTML={{ __html: contributorName }} /></Link>
}

export default ContributorLink;
